import { PureComponent } from 'preact-compat'

export interface TopicMetadataProps {
  publishedAt: string
  replyCount: number
  views: number
  votes?: number
  likes?: number
  category?: string
  forum?: string
}

class TopicMetadata extends PureComponent<TopicMetadataProps> {
  render() {
    const { publishedAt, replyCount, views, votes, likes, category, forum } = this.props
    const showCategoryInfo = Boolean(category && forum)

    return (
      <ul className='topic-moderation--topic-info__metadata'>
        <li className='topic-moderation--topic-info__metadata-item'>{publishedAt}</li>
        {showCategoryInfo && (
          <div className='topic-moderation--topic-info__metadata-item' data-qa='topic-info-metadata-category'>
            <li className='topic-moderation--topic-info__metadata-item'>Category: {category}</li>
            <li className='topic-moderation--topic-info__metadata-item'>Forum: {forum}</li>
          </div>
        )}
        {votes !== undefined && <li className='topic-moderation--topic-info__metadata-item'>Votes: {votes}</li>}
        {likes !== undefined && <li className='topic-moderation--topic-info__metadata-item'>Likes: {likes}</li>}
        <li className='topic-moderation--topic-info__metadata-item'>Replies: {replyCount}</li>
        <li className='topic-moderation--topic-info__metadata-item'>Views: {views}</li>
      </ul>
    )
  }
}

export default TopicMetadata
